import { Highlight } from "@CommonApi/merchflows/_merchflowId_/highlights/base-pogs";
import {
  PlanogramItem,
  PlanogramItemCommonNonCircular,
  UnrangedPlanogramItem,
} from "@CommonTypes/merchflow/pog/item";
import { RelaxedItemConstraint } from "@CommonTypes/merchflow/pog/pog";
import { omniAtom } from "src/utils/atoms";

const prefix = "planogram/extensions";

export const highlightsModeAtom = omniAtom({
  prefix,
  key: "highlights/mode",
  value: false,
});

export const baseHighlightsAtom = omniAtom({
  prefix,
  key: "highlights/base",
  value: null as Highlight[] | null,
});

export const deletedProductAtom = omniAtom({
  prefix,
  key: "deletedProduct",
  value: null as { item: PlanogramItem | UnrangedPlanogramItem; storeCodes: string[] } | null,
});

export const newProductAtom = omniAtom({
  prefix,
  key: "newProduct",
  value: null as PlanogramItemCommonNonCircular | null,
});

export const relaxedItemsAtom = omniAtom({
  prefix,
  key: "relaxedItems",
  value: null as RelaxedItemConstraint[] | null,
});

export const sideViewAtom = omniAtom({
  prefix,
  key: "sideView",
  value: null as {
    bayUniqueId: string;
    itemXLeft: number;
    itemXRight: number;
  } | null,
});
